import { render, staticRenderFns } from "./UserQualification.vue?vue&type=template&id=1362d090&"
import script from "./UserQualification.vue?vue&type=script&lang=js&"
export * from "./UserQualification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./UserQualification.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./UserQualification.vue?vue&type=custom&index=1&blockType=i18n&lang=yaml&locale=dk"
if (typeof block1 === 'function') block1(component)

export default component.exports